/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UnproxiedMcpServerUsageBreakdownPayload,
  UnproxiedMcpServerUsageBreakdownPayload$Outbound,
  UnproxiedMcpServerUsageBreakdownPayload$outboundSchema,
} from "../components/unproxiedmcpserverusagebreakdownpayload.js";

export type GetUnproxiedMcpServerUserUsageSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetUnproxiedMcpServerUserUsageSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetUnproxiedMcpServerUserUsageSecurity = {
  option1?: GetUnproxiedMcpServerUserUsageSecurityOption1 | undefined;
  option2?: GetUnproxiedMcpServerUserUsageSecurityOption2 | undefined;
};

export type GetUnproxiedMcpServerUserUsageRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  unproxiedMcpServerUsageBreakdownPayload:
    UnproxiedMcpServerUsageBreakdownPayload;
};

/** @internal */
export type GetUnproxiedMcpServerUserUsageSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetUnproxiedMcpServerUserUsageSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetUnproxiedMcpServerUserUsageSecurityOption1$Outbound,
    GetUnproxiedMcpServerUserUsageSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getUnproxiedMcpServerUserUsageSecurityOption1ToJSON(
  getUnproxiedMcpServerUserUsageSecurityOption1:
    GetUnproxiedMcpServerUserUsageSecurityOption1,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerUserUsageSecurityOption1$outboundSchema.parse(
      getUnproxiedMcpServerUserUsageSecurityOption1,
    ),
  );
}

/** @internal */
export type GetUnproxiedMcpServerUserUsageSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetUnproxiedMcpServerUserUsageSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetUnproxiedMcpServerUserUsageSecurityOption2$Outbound,
    GetUnproxiedMcpServerUserUsageSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getUnproxiedMcpServerUserUsageSecurityOption2ToJSON(
  getUnproxiedMcpServerUserUsageSecurityOption2:
    GetUnproxiedMcpServerUserUsageSecurityOption2,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerUserUsageSecurityOption2$outboundSchema.parse(
      getUnproxiedMcpServerUserUsageSecurityOption2,
    ),
  );
}

/** @internal */
export type GetUnproxiedMcpServerUserUsageSecurity$Outbound = {
  Option1?: GetUnproxiedMcpServerUserUsageSecurityOption1$Outbound | undefined;
  Option2?: GetUnproxiedMcpServerUserUsageSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetUnproxiedMcpServerUserUsageSecurity$outboundSchema:
  z.ZodMiniType<
    GetUnproxiedMcpServerUserUsageSecurity$Outbound,
    GetUnproxiedMcpServerUserUsageSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        GetUnproxiedMcpServerUserUsageSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        GetUnproxiedMcpServerUserUsageSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function getUnproxiedMcpServerUserUsageSecurityToJSON(
  getUnproxiedMcpServerUserUsageSecurity:
    GetUnproxiedMcpServerUserUsageSecurity,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerUserUsageSecurity$outboundSchema.parse(
      getUnproxiedMcpServerUserUsageSecurity,
    ),
  );
}

/** @internal */
export type GetUnproxiedMcpServerUserUsageRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UnproxiedMcpServerUsageBreakdownPayload:
    UnproxiedMcpServerUsageBreakdownPayload$Outbound;
};

/** @internal */
export const GetUnproxiedMcpServerUserUsageRequest$outboundSchema:
  z.ZodMiniType<
    GetUnproxiedMcpServerUserUsageRequest$Outbound,
    GetUnproxiedMcpServerUserUsageRequest
  > = z.pipe(
    z.object({
      gramKey: z.optional(z.string()),
      gramSession: z.optional(z.string()),
      gramProject: z.optional(z.string()),
      unproxiedMcpServerUsageBreakdownPayload:
        UnproxiedMcpServerUsageBreakdownPayload$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramKey: "Gram-Key",
        gramSession: "Gram-Session",
        gramProject: "Gram-Project",
        unproxiedMcpServerUsageBreakdownPayload:
          "UnproxiedMcpServerUsageBreakdownPayload",
      });
    }),
  );

export function getUnproxiedMcpServerUserUsageRequestToJSON(
  getUnproxiedMcpServerUserUsageRequest: GetUnproxiedMcpServerUserUsageRequest,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerUserUsageRequest$outboundSchema.parse(
      getUnproxiedMcpServerUserUsageRequest,
    ),
  );
}
